import { render, staticRenderFns } from "./DashboardHomeStats.vue?vue&type=template&id=31a99f3a&scoped=true"
import script from "./DashboardHomeStats.vue?vue&type=script&lang=js"
export * from "./DashboardHomeStats.vue?vue&type=script&lang=js"
import style0 from "./DashboardHomeStats.vue?vue&type=style&index=0&id=31a99f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a99f3a",
  null
  
)

export default component.exports